import { render, staticRenderFns } from "./vlcPlayer.vue?vue&type=template&id=30907c38&scoped=true"
import script from "./vlcPlayer.vue?vue&type=script&lang=js"
export * from "./vlcPlayer.vue?vue&type=script&lang=js"
import style0 from "./vlcPlayer.vue?vue&type=style&index=0&id=30907c38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30907c38",
  null
  
)

export default component.exports